/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import React from "react";
import { Route, Switch } from "react-router-dom";
import { Box } from "@material-ui/core";
//custom libraries
import { Header } from "../components";
import {
  CustomerProvider,
  useCSRValue,
  useSelectedStoreValue,
} from "../context";
import {
  CLIENTS_REPORT,
  CUSTOMER,
  CUSTOMER_DETAILS,
  CUSTOMER_NEW,
} from "../constants/routes";
import { AddCustomer, CustomerSearch, CustomerDetail } from ".";

export default function Customer() {
  const { csr } = useCSRValue();
  const { selectedStore } = useSelectedStoreValue();

  return (
    <Box display="flex" flexDirection="column" className="min-device-height">
      <Box>
        <Header
          shopAs={false}
          username={csr && csr.userLoggedIn}
          storefront={selectedStore ? true : false}
        />
      </Box>
      <Box flexGrow={1}>
        <CustomerProvider>
          <Switch>
            <Route exact path={CUSTOMER}>
              <CustomerSearch />
            </Route>
            <Route exact path={CUSTOMER_NEW}>
              <AddCustomer />
            </Route>
            <Route exact path={CUSTOMER_DETAILS}>
              <CustomerDetail />
            </Route>
          </Switch>
        </CustomerProvider>
      </Box>
    </Box>
  );
}
